import React from "react";
import CartTabs from "./Cart/CartTabs";
import Basket from "./Cart/Basket/Basket";
import OrderProps from "./Cart/OrderProps/OrderProps";
import {Navigate} from "react-router-dom";
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';

class SaleOrderAjaxCart extends React.Component {
    render() {
            if (this.props.basketItems.length === 0 && this.props.wishList.length === 0) {
                window.location.href = '/catalog/';
                return (<div>{/*0&&this.state.toString()*/}</div>)
            } else if (this.props.basketItems.length === 0)
                return (<Navigate to="/cart/wishlist/"/>);

        const {orderProps, basketItems ,wishList} = this.props;

        return (
            <div className="cart">

                <CartTabs
                    activeButton={"cart"}
                    cart={basketItems.length}
                    wishList={wishList.length}
                />

                <Basket
                    items={basketItems}
                    zeroPrice={this.props.zeroPrice}
                    deliveryPrice={this.props.deliveryPrice}
                    _onChangeBasketHandle={(value, index) => this.props._onChangeBasketHandle(value, index)}
                    _onRemoveBasketItem={id=>this.props._onRemoveBasketItem(id)}

                />
                <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CATCHA_KEY}>
                    <OrderProps
                        vars={orderProps}
                        zeroPrice={this.props.zeroPrice}
                        totalPrice={this.props.totalPrice + this.props.deliveryPrice}
                        deliveryPrice={this.props.deliveryPrice}
                        _onOrder={this.props._onOrder}
                    />
                </GoogleReCaptchaProvider>


            </div>
        );
    }
}

export default SaleOrderAjaxCart;